import { createContext, useReducer, Dispatch, ReactNode } from "react";
import { AppState, AppAction } from "./types";

// Reducer
const initialState: AppState = {
  reinit_upload: false,
  permission_changed: false,
  check_notification: false,
  data: {},
  callback: undefined,
};

export function appReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case "TRIGGER_PERMISSION_CHANGED":
      return {
        ...state,
        reinit_upload: !state.reinit_upload,
      };
    case "TRIGGER_UPLOAD":
      return {
        ...state,
        data: action.data,
      };
    case "TRIGGER_UPLOAD_DATA":
      return {
        ...state,
        data: action.data,
      };
    case "TRIGGER_NOTIFICATION":
      return {
        ...state,
        check_notification: !state.check_notification,
      };
    default:
      return state;
  }
}

// Context
type AppContextType = {
  state: AppState;
  dispatch: Dispatch<AppAction>;
};

export const AppContext = createContext<AppContextType>({
  state: initialState,
  dispatch: () => null,
});

// Provider
export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};
